import React from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import Icon from 'components/common/Icon'
const SubTools = ({ view, uiStore, selectionStore }) => {
  const handleClose = (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault()
    if (e && typeof e.stopPropagation === 'function') e.stopPropagation()

    const map = uiStore && uiStore.map && uiStore.map.leafletElement
    const center = map && typeof map.getCenter === 'function' ? map.getCenter() : null
    const zoom = map && typeof map.getZoom === 'function' ? map.getZoom() : null
    const currentBounds = map && typeof map.getBounds === 'function' ? map.getBounds() : null
    const prevZoomToSelected = uiStore && typeof uiStore.zoomToSelected !== 'undefined'
      ? uiStore.zoomToSelected
      : null

    if (uiStore && prevZoomToSelected !== null) {
      uiStore.zoomToSelected = false
    }
    if (uiStore && typeof uiStore.suppressMapBoundsTemporarily === 'function') {
      uiStore.suppressMapBoundsTemporarily(450)
    }

    if (uiStore && currentBounds && typeof uiStore.setBoundsHelper === 'function') {
      uiStore.setBoundsHelper(currentBounds)
    }

    selectionStore.clear()

    // Keep current dragged viewport when closing sub-tools panes, and
    // guard against transient re-focus/zoom side effects on close.
    if (map && center && zoom != null) {
      map.setView(center, zoom, { animate: false })
    }
    setTimeout(() => {
      if (map && center && zoom != null) {
        map.setView(center, zoom, { animate: false })
      }
      setTimeout(() => {
        if (map && center && zoom != null) {
          map.setView(center, zoom, { animate: false })
        }
      }, 50)
      // Keep viewport stable when closing Add Item flow.
      if (uiStore && prevZoomToSelected !== null) {
        uiStore.zoomToSelected = prevZoomToSelected
      }
    }, 0)
  }

  const isBackArrow =
    selectionStore.type === 'NEW_ITEM' ||
    selectionStore.type === 'NEW_TARGET_GROUP' ||
    selectionStore.type === 'BOUNDARY' ||
    selectionStore.type === 'FOLDER_ACTIONS'

  return (
    <div className={classnames({
      tools: true,
      'sub-tools': true,
      loading: uiStore.processing
    })}
    >
      <Icon
        onClick={handleClose}
        extraClasses={['close', ...(isBackArrow ? ['close--back'] : [])]}
        id={isBackArrow ? 'leftarrows' : 'fa-times'}
      />
      {view}
    </div>
  )
}

export default inject('uiStore', 'selectionStore')(
  observer(SubTools)
)
